module.exports = __webpack_public_path__ + "static/visual_6_1_dont-11c86a5af3002dabe1145c8de7f1de3a.png";